import type { RouteObject } from 'react-router-dom';

import { Box } from '@myphx-engineering/phx-design-system';

import AppRoot from '../components/layout/AppRoot';

import routes from './app-routes';
import UnauthHomeRoute from './auth/UnauthHomeRoute';
import cabinetRoutes from './cabinet';
import careCircleRoutes from './care-circle';
import claimsRoutes from './claims';
import drugRoutes from './drug';
import errorRoutes from './error';
import RootErrorRoute from './error/RootErrorRoute';
import helpCenterRoutes from './help-center';
import homeRoutes from './home';
import languageRoutes from './language';
import { medicationRoutes } from './medication';
import ordersRoutes from './orders';
import pharmacyRoutes from './pharmacy';
import planRoutes from './plan';
import priorAuthorizationRoutes from './prior-authorization';
import profileRoutes from './profile';
import simplifiedProvidersRoutes from './simplified';
import startSavingRoutes from './start-saving';
import { transferRoutes } from './transfer';

const root: RouteObject = {
    path: routes.root,
    element: <AppRoot />,
    errorElement: (
        <Box p="md">
            <RootErrorRoute />
        </Box>
    ),
    children: [
        { index: true, element: <UnauthHomeRoute /> },
        ...cabinetRoutes,
        ...careCircleRoutes,
        ...claimsRoutes,
        ...drugRoutes,
        ...errorRoutes,
        ...homeRoutes,
        ...ordersRoutes,
        ...languageRoutes,
        ...pharmacyRoutes,
        ...planRoutes,
        ...profileRoutes,
        ...startSavingRoutes,
        ...transferRoutes,
        ...helpCenterRoutes,
        ...medicationRoutes,
        ...priorAuthorizationRoutes,
        ...simplifiedProvidersRoutes,
    ],
};

export default root;
